import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Vibrant%20abstract%20gaming%20world%20with%20colorful%20floating%20islands%20and%20magical%20particles%2C%20warm%20orange%20and%20coral%20gradients%2C%20stylized%20geometric%20shapes%2C%20energetic%20digital%20art%20style%2C%20cinematic%20wide%20composition&width=1600&height=900&seq=hero-bg-01&orientation=landscape')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 md:mb-6 leading-tight">
          精选热门网页游戏大全
        </h1>
        <p className="text-sm md:text-lg text-white/85 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
          汇聚海量热门网页游戏资源，无需下载即点即玩。覆盖角色扮演、策略、射击、休闲等多种类型，随时随地开启游戏乐趣。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/category"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer inline-block"
          >
            立即探索
          </Link>
          <Link
            to="/article/web-game-beginner-guide"
            className="w-full sm:w-auto px-8 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-full font-medium text-sm md:text-base hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer inline-block"
          >
            新手攻略
          </Link>
        </div>
        <div className="mt-8 md:mt-10 flex flex-wrap items-center justify-center gap-4 md:gap-6 text-white/70 text-xs md:text-sm">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-gamepad-line"></i> 1000+ 精选游戏
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-user-smile-line"></i> 5000万+ 玩家
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-download-cloud-2-line"></i> 无需下载
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-flashlight-line"></i> 即点即玩
          </span>
        </div>
      </div>
    </section>
  );
}